import React from "react";
import styles from './RadioButton.module.scss';
import PropTypes from "prop-types";

const RadioButton = ({
  label,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className={styles.label}>
      <input
        className={styles.input}
        type="radio"
        checked={checked || false}
        onChange={({ target: { checked } })=> {
          onChange(checked);
        }}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
      {label}
    </label>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RadioButton;
